export default __webpack_public_path__ + "static/media/pagination-arrow-left.509fda52.svg";